import { useEffect, useState } from "react";
import client, { apiErr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, LogIn, Phone, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const LateClockIns = ({ refreshKey, onClockedIn }) => {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(null);

  const load = () => client.get("/attendance/late").then((r) => setRows(r.data?.late || [])).catch(() => setRows([]));
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  const clockIn = async (r) => {
    setBusy(r.shiftId);
    try {
      await client.post("/attendance/admin/start", { workerId: r.workerId, siteId: r.siteId });
      toast.success(`${r.workerName} clocked in at ${r.siteName}`);
      load();
      onClockedIn();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(null); }
  };

  if (!rows.length) return null;
  return (
    <Card className="border-amber-300 bg-amber-50/60 p-4 space-y-2" data-testid="late-clockins">
      <h3 className="font-semibold text-amber-800 flex items-center gap-1.5">
        <AlertTriangle className="h-4 w-4" />Not clocked in yet ({rows.length})
      </h3>
      <p className="text-xs text-amber-700">Shifts that started over 15 minutes ago with no clock-in.</p>
      {rows.map((r) => (
        <div key={r.shiftId} className="flex flex-wrap items-center justify-between gap-2 rounded-lg bg-white border border-amber-200 px-3 py-2" data-testid={`late-row-${r.shiftId}`}>
          <div className="min-w-0">
            <p className="font-medium text-slate-900">{r.workerName}</p>
            <p className="text-xs text-slate-500">{r.siteName} · {r.startTime}–{r.endTime} · <span className="font-semibold text-amber-700">{r.minutesLate} min late</span></p>
          </div>
          <div className="flex gap-2">
            {r.phone && (
              <Button asChild size="sm" variant="outline" data-testid={`late-call-${r.shiftId}`}>
                <a href={`tel:${r.phone}`}><Phone className="h-3.5 w-3.5 mr-1" />Call</a>
              </Button>
            )}
            <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700" disabled={busy === r.shiftId} onClick={() => clockIn(r)} data-testid={`late-clockin-${r.shiftId}`}>
              {busy === r.shiftId ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <><LogIn className="h-3.5 w-3.5 mr-1" />Clock in</>}
            </Button>
          </div>
        </div>
      ))}
    </Card>
  );
};
